<template>
  <div class="language-layout">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'LanguageLayout',
  created() {
    // Set language based on route when component is created
    const lang = this.$route.path.split('/')[1];
    this.$i18n.locale = lang;
  },
  watch: {
    // Watch for route changes and update language
    '$route'(to) {
      const lang = to.path.split('/')[1];
      this.$i18n.locale = lang;
    }
  }
}
</script>